export default "__VITE_ASSET__DUlH$4vQ__"